import { QueryCache, QueryClient } from '@tanstack/react-query'
import { ApiError } from 'utils'

const FIVE_MINUTES_IN_MS = 1000 * 60 * 5 // milliseconds,

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true,
      staleTime: FIVE_MINUTES_IN_MS,
      retry: (failureCount, error) => {
        if (failureCount > 3) return false
        return error instanceof ApiError && (error.status >= 500 || error.status === 401)
      },
      retryDelay: (retryCount) => 3000 * 3 ** (retryCount - 1) // 3s, 9s, 27s
    }
  },
  queryCache: new QueryCache({
    onError: (error) => {
      if (error instanceof ApiError && error.status === 401) {
        // updateHttpClientToken()
      }
    }
  })
})
